import Vue from 'vue';
import axios from 'axios';

import LkAdmin from './lkadmin/lkadmin';

import {
  LocaleProvider,
  Button,
  Table,
  Layout,
  Menu,
  Icon,
  Input,
  Breadcrumb,
  Modal,
  Radio,
  Form,
  Upload,
  Tree,
  Timeline,
  Transfer,
  Tooltip,
  Pagination,
  Tabs,
  Anchor,
  Checkbox,
  Select,
  Spin,
  Message,
  InputNumber,
  Dropdown,
  DatePicker,
  Card,
  Steps,
  Row,
  Col,
  Popover,
  Divider,
} from 'ant-design-vue';
import {
  install
} from './components';
const TextArea = Input.TextArea;
import App from './App.vue';
import {
  router,
  Router
} from './router';
import VueAxios from "vue-axios";
import {
  http
} from "@/utils/http";
import _ from 'lodash';


Vue.config.productionTip = false;
Vue.use(VueAxios, http);
Vue.use(LocaleProvider);
Vue.use(Button);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Table);
Vue.use(Breadcrumb);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Form);
Vue.use(Upload);
Vue.use(Tree);
Vue.use(Transfer);
Vue.use(Timeline);
Vue.use(Tooltip);
Vue.use(Pagination);
Vue.use(Tabs);
Vue.use(TextArea);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Anchor);
Vue.use(Spin);
Vue.use(Message);
// Vue.use(Confirm);
Vue.use(InputNumber);
Vue.use(Dropdown);
Vue.use(DatePicker);
Vue.use(Card);
Vue.use(Steps);
Vue.use(Row);
Vue.use(Col);
Vue.use(Popover);
Vue.use(Divider);
Vue.use(_);
Message.config({
  top: `100px`,
  duration: 3,
  maxCount: 2
});

// antd.Modal.confirm()
Vue.prototype.$Message = Message;
Vue.prototype.$Confirm = Modal.confirm;
Vue.prototype.$Success = Modal.success;
Vue.prototype.$info = Modal.info;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$axios = axios;
Vue.prototype.$EventBus = new Vue();

// (function (Vue) {
//   Object.defineProperty(Vue.prototype, '$appLayout', {
//     get: function () {
//       // this will be each <LkLayout />
//       return this.$root._appLayout;
//     },
//   });
//
//   Vue.prototype.$Message = Message;
//
//   Vue.mixin({
//     created() {
//       // router view
//       const pnode = this.$options._parentVnode;
//       if (pnode && pnode.data && pnode.data.registerRouteInstance) {
//         this.$nextTick(() => this.$appLayout.mvcMayChange());
//       }
//     },
//   });
// })(Vue);

install(Vue);
Vue.use(Router);
Vue.use(LkAdmin);


new Vue({
  router,
  render: h => h(App),
}).$mount('#app');